module.exports = __webpack_public_path__ + "img/bottle-cap.7dd727a8.png";